import React from "react";
import styled from "styled-components";
import Icon from "components/atoms/Icon";
import { ColorSystem, COLOR_SYSTEM } from "components/design/design-system";
import { typography } from "components/design/typography";

type Variant = "Ghost" | "Tinted" | "Outlined" | "Contained";
type Size = "Small" | "Medium";

export interface TagProps {
  /** Tag 크기 */
  size: Size;
  /** Tag 종류 */
  variant: Variant;
  /** Tag 색상 */
  color: ColorSystem;
  /** Tag 안의 내용 */
  children?: React.ReactNode;
  /** Tag 왼쪽 아이콘 존재 여부 */
  left?: boolean;
  /** Tag 오른쪽 아이콘 존재 여부 */
  right?: boolean;
  /** 아이콘 */
  icon?: string;
  /** Inline CSS */
  style?: React.CSSProperties;
}

interface TagStyleProps {
  variant: Variant;
  color: ColorSystem;
  size: Size;
}

const TagWrapper = styled.div<TagStyleProps>`
  ${typography.get("CaptionBold")};
  height: ${({ size }) => (size === "Medium" ? "28px" : "20px")};
  padding: ${({ size }) => (size === "Medium" ? "0 8px" : "0 6px")};
  min-width: ${({ size }) => (size === "Medium" ? "28px" : "20px")};
  background-color: ${({ variant, color }) => {
    if (variant === "Tinted") {
      switch (color) {
        case "Blue":
          return COLOR_SYSTEM.get(color)?.[10];
      }
      return COLOR_SYSTEM.get(color)?.[color === "Gray" ? 20 : 10];
    }
    if (variant === "Contained") {
      switch (color) {
        case "Blue":
          return COLOR_SYSTEM.get(color)?.[400];
        case "Orange":
        case "Gray":
          return COLOR_SYSTEM.get(color)?.[400];
          break;
        case "Red":
          return COLOR_SYSTEM.get(color)?.[300];
        case "Green":
        case "Brown":
          return COLOR_SYSTEM.get(color)?.[500];
        case "Black":
          return COLOR_SYSTEM.get("Gray")?.[900];
      }
      return COLOR_SYSTEM.get("Gray")?.[900];
    }
  }};
  color: ${({ variant, color }) => {
    if (variant === "Contained") return COLOR_SYSTEM.get("Gray")?.[0];
    return COLOR_SYSTEM.get(color)?.[400];
  }};
  border: ${({ variant, color }) => {
    if (variant === "Outlined")
      return `1px solid ${COLOR_SYSTEM.get(color)?.[50]}`;
  }};
  border-radius: ${({ size }) => (size === "Medium" ? "28px" : "20px")};
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

const Tag: React.FC<TagProps> = ({
  size,
  variant,
  color,
  children,
  left = false,
  right = false,
  icon,
  style,
}) => {
  return (
    <TagWrapper variant={variant} color={color} style={style} size={size}>
      {left && icon && (
        <Icon
          name={icon}
          color={COLOR_SYSTEM.get(color)?.[400]}
          size={size === "Medium" ? 14 : 12}
        />
      )}
      {children}
      {right && icon && (
        <Icon
          name={icon}
          color={COLOR_SYSTEM.get(color)?.[400]}
          size={size === "Medium" ? 14 : 12}
        />
      )}
    </TagWrapper>
  );
};

export default Tag;
